import { useEffect } from 'react';

import { useAnalytics } from '@/services/analytics';

import { useAuth } from '@/services/auth';
import ErrorPage from './ErrorPage';

const PasswordReset = () => {
    const mixpanel = useAnalytics();
    const { user } = useAuth();

    useEffect(() => {
        mixpanel?.track('reset-password', { event: 'view' });
    }, []);

    return (
        <ErrorPage title="Check your mailbox" description={`Please click the link we sent to ${user?.email} within the next 10 minutes`} />
    );
};

export default PasswordReset;
